import { List_Item_default } from "./chunk-SDFOHCHN.js";
import { List_default } from "./chunk-KVTI64ME.js";

// src/elements/List/index.ts
var ListComponent = List_default;
ListComponent.Item = List_Item_default;
ListComponent.Item.displayName = "List.Item";
export { ListComponent };